/* @ngInject */
const data = () => {
  const self = {}

  self.myDispatches = []

  return self
}

export default data



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/dispatch/services/data.service.js